/**
 * The three answers an operating system can give about notifications.
 *
 * Listed once, as values, so the Zod schema that persists one
 * (`reportedPushPermissionStore`) and the type everything else uses cannot
 * drift apart.
 *
 * It sits in its own module, imported by `services/firebase.ts` rather than
 * declared there, because a module that only needs the vocabulary must not have
 * to load the Firebase SDK to get it. `reportedPushPermissionStore` builds its
 * schema at module scope, and importing the list from `firebase.ts` made that
 * evaluation depend on a module whose own graph leads back to it: the array was
 * still `undefined` when `z.enum` read it, and every test file that
 * transitively imported the store died on `Cannot convert undefined or null to
 * object`. A leaf with no imports of its own cannot be caught in that cycle.
 */
export const NOTIFICATION_PERMISSION_STATUSES = [
  "notDetermined",
  "authorized",
  "denied",
] as const;

export type NotificationPermissionStatus =
  (typeof NOTIFICATION_PERMISSION_STATUSES)[number];
